import { getPrefixFromPhoneCountry } from '../../models/serializable/phone-country.js';
import { PhoneNumber } from '../../models/serializable/phone-number.js';
import { PhoneNumberFormatter } from './phone-number-formatter.js';

export class RomanianPhoneNumberFormatter extends PhoneNumberFormatter {
  formattedNumber = '';

  format(phoneNumber: PhoneNumber): string {
    this.formattedNumber += getPrefixFromPhoneCountry(phoneNumber.country);
    this.formattedNumber += ' ';
    this.formattedNumber += phoneNumber.number.substring(0, 3);
    this.formattedNumber += ' ';
    this.formattedNumber += phoneNumber.number.substring(3, 6);
    this.formattedNumber += ' ';
    this.formattedNumber += phoneNumber.number.substring(6);

    return this.formattedNumber;
  }
}
